/*
  Menu desktop : l'item de la section en cours de lecture est actif.
  La section active est la dernière cible du menu dont le haut a passé la
  ligne de lecture (40 % de la hauteur de l'écran). Entre deux cibles, l'item
  précédent reste actif (ex. Experience → Home). En bas de page, la dernière
  cible (Contact) devient active même si elle n'atteint pas la ligne. Tout en
  haut de la page, aucun item n'est actif.
*/
const READING_LINE = 0.4;

export function initScrollSpy() {
  const items = [...document.querySelectorAll<HTMLAnchorElement>('[data-scroll-spy] a[href*="#"]')]
    .map((link) => {
      const url = new URL(link.href);
      const target =
        url.pathname === location.pathname ? document.querySelector<HTMLElement>(url.hash) : null;
      return { link, target };
    })
    .filter(
      (item): item is { link: HTMLAnchorElement; target: HTMLElement } => item.target !== null,
    );
  if (!items.length) return;

  let current: HTMLAnchorElement | undefined;
  let ticking = false;

  const update = () => {
    ticking = false;
    const line = window.innerHeight * READING_LINE;
    const atTop = window.scrollY <= 2;
    const atBottom =
      window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
    let active = !atTop && atBottom ? items.at(-1) : undefined;
    if (!active && !atTop) {
      for (const item of items) {
        if (item.target.getBoundingClientRect().top <= line) active = item;
      }
    }
    if (active?.link === current) return;
    current?.classList.remove('is-active');
    current?.removeAttribute('aria-current');
    current = active?.link;
    current?.classList.add('is-active');
    current?.setAttribute('aria-current', 'location');
  };

  const request = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  };

  addEventListener('scroll', request, { passive: true });
  addEventListener('resize', request);
  update();
}
